"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactTitleProperty = exports.factTitlePropertyDefinition = void 0;
exports.factTitlePropertyDefinition = {
    view: {
        label: 'Fact Title',
        style: 'h3',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 72,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'fact-title',
};
const isFactTitleProperty = (prop) => {
    return prop.name === exports.factTitlePropertyDefinition.name;
};
exports.isFactTitleProperty = isFactTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC10aXRsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ZhY3QtdGl0bGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsWUFBWTtRQUNuQixLQUFLLEVBQUUsSUFBSTtLQUNaO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxJQUFrQixFQUE2QixFQUFFO0lBQ25GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CIn0=